module.exports = __webpack_public_path__ + "img/aangetekend-mailen.be67ec75.svg";